import React from "react";
import { CiLocationOn } from "react-icons/ci";
import { Like, Stars, onestar } from "../../assets/images";
import { CarPricing, Features } from "../";
import { VehicleType } from "../../types";

type CarProfileProps = {
  vehicle: VehicleType;
  distance: number;
};

const CarProfile: React.FC<CarProfileProps> = ({ vehicle, distance }) => {
  return (
    <div className="w-full  flex flex-col gap-[30px]  ">
      <div className="flex w-full  justify-between bg-white relative pb-5">
        <div className="flex flex-col gap-4 w-[90%] mx-auto">
          <div className="flex flex-col gap-4">
            <p className="flex flex-col md:flex-row gap-5 text-[#1a202c] flex-wrap font-Jakarta text-[22px] lg:text-[32px] font-bold leading-[48px] items-center ">
              {vehicle?.make}
              <span className="flex gap-1 text-[#90a3bf] font-Jakarta whitespace-nowrap font-medium text-[8px] lg:text-[10px] border border-[#90a3bf] px-1 rounded-3xl  items-center h-[50px] ">
                <CiLocationOn size={15} color="darkGreen" />
                <span className="p-0 m-0">{distance} away</span>
              </span>
            </p>
            <div className="flex gap-2 w-[50%] ">
              {/* <img src={Stars} alt="" className="w-[60%]" /> */}
              <img src={onestar} alt="" />
              <p className="text-[#596780] font-Jakarta text-[14px] font-normal ">
                {/* {vehicle?.rating} */}
                {vehicle.carRatings.length
                  ? (
                      vehicle.carRatings.reduce(
                        (acc, curr) => acc + curr.meanRating,
                        0
                      ) / vehicle.carRatings.length
                    ).toFixed(1)
                  : "0.0"}
              </p>
            </div>
          </div>
          <div className="flex flex-col">
            <Features vehicle={vehicle} />
          </div>
          <div className="w-full">
            <CarPricing vehicle={vehicle} />
          </div>
        </div>
        <img src={Like} alt="" className="absolute right-0 p-2 top-0" />
      </div>
    </div>
  );
};

export default CarProfile;
